export default "__VITE_ASSET__BUguj$tw__"